export default __webpack_public_path__ + "static/media/thumb_down_off.78391da2.svg";